export default () => ({
  usersData: [],
  userReputationScores: {},
});
